import { DEFAULT_PAGINATION_MODEL } from 'global-constants';
import { JamfAssetsState } from './types';

export const INITIAL_STATE: () => JamfAssetsState = () => {
  return {
    jamfAssets: [],
    count: 0,
    jamfAssetsLoadingState: 'idle',
    paginationModel: DEFAULT_PAGINATION_MODEL,
  };
}; 
